import { removeList } from './removeList.mjs';
import { insertList } from './insertList.mjs';
import { isListToggleActive } from '../queries/isListToggleActive.mjs';

function toggleList(editor, {
  at,
  listType,
  defaultBlockType
}) {
  if (isListToggleActive(editor, {
    at,
    listType
  })) {
    removeList(editor, {
      at,
      defaultBlockType
    });
  } else {
    insertList(editor, {
      at,
      defaultBlockType,
      listType
    });
  }
}

export { toggleList };
